export default __webpack_public_path__ + "static/media/img13.e5c70684.jpeg";